module.exports = __webpack_public_path__ + "media/customizations/ranchlife/logo-6afcaf65d480a2d717c1113a0600f3ca.png";